<rotec-modal-v2
  [title]="modalTitle"
  [translateTitle]="false"
  [hideModalTitle]="true"
  [disablePaddingMainPart]="true"
  [darkMode]="true"
  width="80vw"
  height="95vh"
  #modal
>
  <ng-container ngProjectAs="modal-main">
    <ma-task-modal-main [taskInfos]="taskInfos" [assetPictureId]="pictureId">
      <div class="task-buttons">
        @if (userRightsService.hasActionRights$(actions.deleteTask) | async) {
          <div class="delete-icon _flex-row-centered" (click)="deleteTask()">
            <rotec-icon-v2 svgIcon="trash"></rotec-icon-v2>
            <span>{{ (isSeries ? 'Delete Series' : 'Delete Task') | translate }}</span>
          </div>
        }
        @if (userRightsService.hasActionRights$(actions.updateTask) | async) {
          <div class="edit-icon _flex-row-centered" (click)="openEditModal()">
            <rotec-icon-v2 svgIcon="edit"></rotec-icon-v2>
            <span>{{ (isSeries ? 'Edit series' : 'Edit') | translate }}</span>
          </div>
        }
      </div>
      <ma-task-info
        [task]="task"
        [details]="details"
        [readonly]="!(userRightsService.hasActionRights$('Add') | async)"
        (notesChange)="editNotes($event)"
      >
      </ma-task-info>
      <!-- done/shift/skip switch -->
      @if (userRightsService.hasActionRights$('Add') | async) {
        <rotec-radio-row-v2
          [spaceEvenly]="true"
          [options]="options"
          [selected]="view"
          (selectedChange)="view = $event"
          [darkMode]="true"
        ></rotec-radio-row-v2>
      }
      <br />
      @if (userRightsService.hasActionRights$('Add') | async) {
        <div>
          @switch (view) {
            @case (machineTaskModalView.Done) {
              <div class="row-title _flex-row">
                <h3 translate>Description</h3>
                <rotec-icon-v2
                  [svgIcon]="!description ? 'asterisk' : 'check'"
                  [color]="!description ? 'pink' : 'light-gray'"
                ></rotec-icon-v2>
              </div>
              <rotec-textarea-v2
                [value]="description"
                (valueChange)="description = $event"
                [darkMode]="true"
                [placeholder]="'Please enter text in order to be able to confirm' | translate"
                minHeight="200px"
                name="description"
              ></rotec-textarea-v2>
              <ma-task-documents
                [documentIds]="task?.taskDocumentIds"
                [documentsLoading]="taskModalService.taskLoading$ | async"
                (documentIdsChange)="setDocuments($event)"
              ></ma-task-documents>
            }
            @case (machineTaskModalView.Shift) {
              <h3 translate>New due date</h3>
              <rotec-datepicker-v2
                [value]="newDueDate"
                (valueChange)="changeDueDate($event)"
                (inputChange)="onDateInputChanged($event)"
                (blur)="onDateLeave($event)"
                [min]="minDate"
                [darkMode]="true"
                [hasError]="errorMsg === 'VALIDATION_ERROR_INVALID_TASK_ACTION_SHIFTED_DUE_DATE'"
                [readonly]="!(userRightsService.hasActionRights$('Add') | async)"
              ></rotec-datepicker-v2>
              @if (errorMsg === 'VALIDATION_ERROR_INVALID_TASK_ACTION_SHIFTED_DUE_DATE') {
                <p class="error">
                  {{ errorMsg | translate }}
                </p>
              }
              <div class="row-title _flex-row">
                <h3 translate>Reason why the task was shifted</h3>
                <rotec-icon-v2
                  [svgIcon]="!description ? 'asterisk' : 'check'"
                  [color]="!description ? 'pink' : 'light-gray'"
                ></rotec-icon-v2>
              </div>
              <rotec-textarea-v2
                [value]="description"
                (valueChange)="description = $event"
                [darkMode]="true"
                [placeholder]="'Please enter text in order to be able to confirm' | translate"
                minHeight="200px"
                name="description"
                [readonly]="!(userRightsService.hasActionRights$('Add') | async)"
              ></rotec-textarea-v2>
            }
            @case (machineTaskModalView.Skip) {
              <div class="row-title _flex-row">
                <h3 translate>Reason why the task is skipped</h3>
                <rotec-icon-v2
                  [svgIcon]="!description ? 'asterisk' : 'check'"
                  [color]="!description ? 'pink' : 'light-gray'"
                ></rotec-icon-v2>
              </div>
              <rotec-textarea-v2
                [value]="description"
                (valueChange)="description = $event"
                [darkMode]="true"
                [placeholder]="'Please enter text in order to be able to confirm' | translate"
                minHeight="200px"
                name="description"
                [readonly]="!(userRightsService.hasActionRights$('Add') | async)"
              ></rotec-textarea-v2>
            }
          }
        </div>
      }
      <!-- end of done/shift/skip switch -->
    </ma-task-modal-main>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    @if (userRightsService.hasActionRights$('Add') | async) {
      <button rotec-button-secondary dark (click)="close()">
        {{ 'COMMON_Cancel' | translate }}
      </button>
    } @else {
      <button rotec-button-primary-v2 dark (click)="close()">
        {{ 'COMMON_Close' | translate }}
      </button>
    }
    @if (userRightsService.hasActionRights$('Add') | async) {
      <button rotec-button-primary-v2 dark [disabled]="isConfirmBtnDisabled" (click)="confirm()">
        {{ 'COMMON_Confirm' | translate }}
      </button>
    }
  </ng-container>
</rotec-modal-v2>
